module.exports = __webpack_public_path__ + "static/media/icon-upload.b7e6adf0.svg";